import { render } from "./UserForm.vue?vue&type=template&id=0b7961ea"
import script from "./UserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/user/components/UserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b7961ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b7961ea', __exports__)) {
    api.reload('0b7961ea', __exports__)
  }
  
  module.hot.accept("./UserForm.vue?vue&type=template&id=0b7961ea", () => {
    api.rerender('0b7961ea', render)
  })

}


export default __exports__